import { useEffect, useState } from 'react'
import AdminTicket from './AdminTicket'
import { useQuery } from '@apollo/client'
import { GET_TICKET_BY_STATUS_INPUT } from '../../../graphql/query'
import { PageTitle } from '../../../layout/core'

const AdminTicketIndex = () => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [ticketData, setTicketData] = useState<any>([])
  const [ticketCount, setTicketCount] = useState<any>()
  const showEnteries = 10
  const [selectedStatus, setSelectedStatus] = useState<any>(null)
  const [searchQuery, setSearchQuery] = useState<any>('')
  const [priority, setPriority] = useState<any>(null)
  const { data, loading, error, refetch } = useQuery(GET_TICKET_BY_STATUS_INPUT, {
    variables: {
      input: {
        Status: selectedStatus,
        query: searchQuery,
        Priority: priority,
        limit: showEnteries,
        offset: (currentPage - 1) * showEnteries
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'SuperAdmin-Tickets'
      }
    }
  })

  if (error) {
    console.log(error)
  }

  useEffect(() => {
    if (data) {
      setTicketData(data?.getTicketbyStatus?.tickets)
      setTicketCount(data?.getTicketbyStatus?.ticketcount)
    }
  }, [data, selectedStatus])

  return (
    <div className='card mb-5 mb-xl-8'>
      <PageTitle breadcrumbs={[]}>Customer Support</PageTitle>
      <div>
        <AdminTicket
          setSelectedStatus={setSelectedStatus}
          selectedStatus={selectedStatus}
          loading={loading}
          refetch={refetch}
          ticketCount={ticketCount}
          ticketData={ticketData}
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          showEnteries={showEnteries}
          priority={priority}
          setPriority={setPriority}
        />
      </div>
    </div>
  )
}

export default AdminTicketIndex
